import qs from 'query-string';
import { useHistory, useParams } from 'react-router-dom';

function useQueryParams() {
	const params = useParams();
	const history = useHistory();
	const searchQuery = typeof window !== 'undefined' && qs.parse(window.location.search);
	const handleHistoryChange = (options) => {
		const { pathname = window.location.pathname, query, isReplace = false } = options;

		const updateQuery = qs.stringify(query);
		const newUrl = `${pathname}?${updateQuery}`;
		history[isReplace ? 'replace' : 'push'](newUrl);
	};
	const setParams = (callback) => {
		const options = callback(searchQuery);
		return handleHistoryChange(options);
	};
	return { params: { ...params, ...searchQuery }, setParams };
}

export default useQueryParams;
